import React from "react";
import Prime from "./Prime";
import FloatingButton from "./components/FloatingButton";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="font-bodyFont">
      <Prime />
      <FloatingButton />
      <Toaster />
    </div>
  );
}

export default App;
